<template>
  <div class="chrray-content" v-loading="loadings">
    <div class="device-info" @click="handle">{{ cameraInfo && cameraInfo.name || '暂无设备' }}</div>
    <div
      class="device-content"
      :class="cameraInfo.hasOwnProperty('child') ? 'more' : 'one'">
      <template v-for="(item, index) in list.slice(0, cameraInfo.hasOwnProperty('child') ? list.length : 1)">
        <div
          v-if="item"
          :key="index"
          class="contents">
          <div class="flex-row">
            <p>{{ item.name }}</p>
            <el-dropdown trigger="click" @command="handleCommand(item, $event, index)">
            <span class="el-dropdown-link">
              <i class="el-icon-more icon"></i>
            </span>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="edit">编辑</el-dropdown-item>
                <el-dropdown-item command="delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div :id="'myPlayer' + index" class="canvas-img"></div>
        </div>
      </template>
    </div>
    <el-pagination
      style="text-align: right;margin-top: 20px"
      background
      layout="prev, pager, next"
      :page-size="4"
      :current-page="page"
      @current-change="handleCurrentChange"
      :total="total">
    </el-pagination>
    <!-- 修改摄像头 -->
    <edit-camera
      :show="cameraShow"
      :title="'添加摄像头'"
      :model="'cameraShow'"
      :devId="devId"
      :form="camera"
      :item="cameraItem"
      @success="handleAddCamera"
      @close="handleClose">
    </edit-camera>
  </div>
</template>

<script>
  import EZUIKit from "ezuikit-js";
  import { getStorage } from "../../../utils/localStorage";
  import editCamera from './dialog/camera';
  import { deleteCamera, cameraPageList } from "../../../api/monitor";
  import { mapGetters } from 'vuex';
  var player = ''
  export default {
    name: "monitorContent",
    props: {
      device: {
        type: Object,
        default: () => {}
      }
    },
    components: {
      editCamera
    },
    computed: {
      ...mapGetters({
        cameraInfo: 'cameraInfo'
      })
    },
    data() {
      return {
        list: [],
        more: true,
        player: null,
        cameraShow: false,
        devId: 0,
        camera: [
          { label: '摄像头名称', key: 'name' },
          { label: '监控数据源', key: 'monitoringUrl' },
          { label: '摄像头区域', key: 'dangerInfoId', type: 'select' },
        ],
        cameraItem: {},
        page: 1,
        total: 0,
        playerList: [],
        loadings: false
      }
    },
    mounted() {
      //
    },
    methods: {
      handle() {
        this.more = !this.more;
      },
      //  显示监控
      initVideo(url, index) {
        const appToken = JSON.parse(getStorage('appToken'));
        if (appToken) {
          this.playerList[index]['player'] =  new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: `myPlayer${index}`,
            accessToken: appToken.accessToken,
            url,
            template: "simple",
            width: 600,
            height: 400
          });
          this.playerList[index]['player'].play();
        } else {
          // console.log(`暂无token`)
        }
      },
      //  处理编辑事件
      handleCommand(item, key, index) {
        if (key === 'edit') {
          this.cameraShow = true;
          this.cameraItem = item;
        } else if (key === 'delete') {
          this.$confirm('此操作将删除摄像头, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '删除中...';
                deleteCamera(item.id).then(() => {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = '确定';
                  done();
                  this.$message.success(`摄像头删除成功`);
                  this.list.splice(index, 1);
                  setTimeout(() => {
                    location.reload();
                  }, 1000)
                })
              } else {
                done();
              }
            }
          }).catch(() => {
            //
          });
        }
      },
      //
      handleAddCamera() {
        location.reload();
        // this.getDeviceList();
      },
      //  分页改变
      handleCurrentChange(val) {
        const that = this;
        this.page = val;
        that.list = [];
        setTimeout(() => {
          that.list.forEach((v, i) => {
            let item = {
              player: '',
              id: i
            };
            that.playerList.push(item);
          })
        }, 1000)

        setTimeout(() => {
          const params = { id: this.cameraInfo.id, limit: 4, curPage: this.page };
          cameraPageList(params).then(res => {
            that.list = res.body.data;
            that.total = res.body.cum;
            that.$nextTick(() => {
              that.list.map((v, i) => {
                if (that.list[i]['monitoringUrl']) {
                  // console.log(i)
                  that.initVideo(that.list[i]['monitoringUrl'], i);
                }
              })
            })
          })
        }, 2000)
      },
      //  关闭
      handleClose(key) {
        this[key] = false;
        this.cameraItem = {};
      },
      //  全屏
      fullScreen() {
        player.fullScreen();
      }
    },
    watch: {
      //  摄像头改变
      cameraInfo(val) {
        const that = this;
        that.list = [];
        that.loadings = true;
        //  判断,如果传过来的是设备id,那么就去请求分页.如果是摄像头,就直接回显
        setTimeout(() => {
          that.playerList = [];
          if (val.hasOwnProperty('child')) {
            //  设备 - 请求分页
            const params = { id: val.id, limit: 4, curPage: this.page };
            cameraPageList(params).then(res => {
              that.list = res.body.data;
              that.total = res.body.cum;
              that.list.forEach((v, i) => {
                let item = {
                  player: '',
                  id: i
                };
                that.playerList.push(item);
              })
              that.$nextTick(() => {
                that.list.map((v, i) => {
                  if (that.list[i]['monitoringUrl']) {
                    that.initVideo(that.list[i]['monitoringUrl'], i);
                  }
                })
              })
            })
          } else {
            //  摄像头
            that.list = [val];
            that.list.forEach((v, i) => {
              let item = {
                player: '',
                id: i
              };
              that.playerList.push(item);
            })
            this.$nextTick(() => {
              that.initVideo(that.list[0]['monitoringUrl'], 0);
            })
          }
          that.loadings = false;
        }, 1000)
        // setTimeout(() => {
        //   that.list = val.hasOwnProperty('child') ? val.child : [val];
        //   that.list.forEach((v, i) => {
        //     let item = {
        //       player: '',
        //       id: i
        //     };
        //     that.playerList.push(item);
        //   })
        //   if (val.hasOwnProperty('child')) {
        //     that.$nextTick(() => {
        //       that.list.map((v, i) => {
        //         if (that.list[i]['monitoringUrl']) {
        //           that.initVideo(that.list[i]['monitoringUrl'], i);
        //         }
        //       })
        //     })
        //   } else {
        //
        //   }
        //   that.loadings = false;
        // }, 1000)
      },
    }
  }
</script>

<style scoped lang="scss">
.chrray-content {
  flex: 1;
  margin-left: 10px;
  .device-info {
    padding: 10px;
    background-color: #fff;
  }
  .device-content {
    margin-top: 10px;
    overflow-y: scroll;
    &.more {
      height: calc(100% - 103px);
      display: grid;
      grid-template-columns: repeat(2, 664px);
      grid-template-rows: repeat(2, 466px);
      grid-gap: 10px;
    }
    &.one {
      display: flex;
      height: calc(100% - 51px);
      .contents {
        width: 100%;
        height: 100%;
        transition: all .2s;
      }
    }
    .contents {
      width: 100%;
      transition: all .2s;
      background-color: #fff;
      padding: 10px;
      display: flex;
      flex-direction: column;
      .flex-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .canvas-img {
        width: 100%;
        height: 420px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>